// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.podium-content__podium__content {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: var(--space-and-half);
    gap: var(--space-and-half);
    align-items: end;
    /* margin-top: calc(var(--space-x3)*1.6); */
}
.podium-content__podium__content__position{
    display: grid;
    justify-content: center;
    align-items: start;
    margin-top: var(--space);
    margin-bottom: var(--space);
    cursor: pointer;
    justify-items: center;
}
.podium-content__podium__content__position__champion{
    background-color: var(--white-color);
    width: 100%;
    /*height: calc(var(--space-x3) * 2.5);*/
    border-radius: var(--space-half);
   /* box-shadow: 0px 0px 18px rgb(170 193 182 / 61%), -1px 0px 4px rgb(77 84 81 / 32%);*/
    box-shadow: -1px 0 4px 0 rgba(77, 84, 81, 0.32);
}
.podium-content__podium__content__position__champion.color{
    background: linear-gradient(180deg, #FFF3BF 0%, #E4D387 100%);
    width: 20rem;
}
.podium-content__podium__content__position__champion__text{
    margin-top: calc(var(--space-x2) * 2);
    margin-right: calc(var(--space-x3)*1.6);
    width: 100%;
    padding-bottom: var(--space);
    text-align: center;
}
.baloa-subtitle-2.podium-content__podium__content__position__champion__text__title{
    color: var(--basic-gray-color);
}
.podium-content__podium__content__position__champion__text__name.baloa-subtitle-2{
    color: var(--primary-dark-color);
}

.podium-content__podium__content__position__champion__text__name_champion.baloa-headline-2 {
    color: var(--primary-very-dark-color);
}
.podium-content__podium__content__position__champion__text__username.baloa-table-column{
    color: var(--primary-very-dark-color);
}
.podium-content__podium__content__position__champion__text__username.baloa-names{
    color: var(--primary-dark-color);
}
.podium-content__podium__content__position__champion__text__username.baloa-username{
    color: var(--primary-dark-color);
}
.podium-content__podium__content__position__image{    
    border-radius: 50%;
    background: var(--white-color);
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.31) , 0 3px 13px 0 rgba(77, 84, 81, 0.38);
    position: absolute;
    
}

.podium-content__podium__content__position__image.subcampeon__image{
    width: 112px;
    height: 112px;
    margin-top: -60px;
}
.podium-content__podium__content__position__image.champion__image{
    width: 138px;
    height: 138px;
    margin-top: -80px;
}
.podium-content__podium__content__position__image.third__image{
    width: 86px;
    height: 86px;
    margin-top: -40px;
}

.podium-content__podium__content__position__image__content {
    display: flex;
    align-items: center;
    justify-content: center;
}
.podium-content__podium__content__position__image__content .icon-ball.champion  {
    font-size: 120px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 9px;
    color: var(--white-color);
}
.subcampeon__image .podium-content__podium__content__position__image__content .icon-ball  {
    font-size: 100px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 6px;
    color: var(--white-color);
}
.third__image .podium-content__podium__content__position__image__content .icon-ball  {
    font-size: 76px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 5px;
    color: var(--white-color);
}

.podium-content__podium__content__position__champion__subtitle{
    padding: 10px;
    text-align: center;
}

.podium-content__podium__content__position__image__content img.no_img{

    padding: var(--space-half);
    width: calc(var(--space-x3)*1.8);
    height: calc(var(--space-x3)*1.8);
    border-radius: 50%;
}

.podium-content__podium__content__position__image__content img.no_img_champion{
    width: 100%;
    border-radius: 50%;
}

.podium-content__podium__content__position__image__content img.has_img_champion{
    width: 100%;
    border-radius: 50%;
}

.podium-content__podium__content__position__image__content img.has_img{

    width: 100%;
    height: 100%;
    border-radius: 50%;
}

.podium-content__podium__content__position__coach {
    border-top: solid 1px #B6B18E;
    margin-top: var(--space);
    display: flex;
    padding-top: var(--space);
    /* margin-right: var(--space); */
    width: 80%;
    margin-left: var(--space-x2);
    padding-left: 12px;
}

.podium-content__podium__content__position__coach__image {
    align-self: center;
    margin-right: var(--space-half);
}

.podium-content__podium__content__position__coach__image img.has_img{
    width: var(--space-x2);
    height: var(--space-x2);
    border-radius: 50%;
}

.podium-content__podium__content__position__coach__image img.no_img{
    padding: var(--space-quarter);
    width: var(--space-x2);
    height: var(--space-x2);
    border-radius: 50%;
    background-color: var(--white-color);
}

.league-tournament-report__podium__container {
    background-color: var(--white-color);
    padding-top: 100px;
    padding-bottom: var(--space-x2);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .podium-content__podium__content {
        display: flex;
        flex-direction: column;
        align-items: center;

    }

    .podium-content__podium__content__position:nth-of-type(1) {
        order: 2;
        margin-top: calc( var(--space-x3) + var(--space-half) );
    }

    .podium-content__podium__content__position:nth-of-type(2) {
        order: 1;
    }
    
    .podium-content__podium__content__position:nth-of-type(3) {
        order: 3;
    }

    .podium-content__podium__content__position:nth-of-type(3) .podium-content__podium__content__position__champion__text {
        margin-top: var(--space-x3);
    }

    .league-tournament-report__podium__container {        
        padding-top: 50px;        
    }    

    .podium-content__podium__content__position__image.champion__image {
        width: 100px;
        height: 100px;
        margin-top: -54px;
    }

    .podium-content__podium__content__position__image.subcampeon__image {
        width: 90px;
        height: 90px;
        margin-top: -45px;
    }
    .third__image .podium-content__podium__content__position__image__content .icon-ball {
        font-size: 57px;
    }
    .podium-content__podium__content__position__image.third__image {
        width: 66px;
        height: 66px;
        margin-top: -32px;
    }
    .podium-content__podium__content__position__image.third__image img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }

    .subcampeon__image .podium-content__podium__content__position__image__content .icon-ball {
        font-size: 78px;
    }

    .podium-content__podium__content__position__image.champion__image span {
        font-size: 90px;
        font-weight: var(--font-bold);
        border-radius: 50%;
        padding: 5px;
        color: var(--white-color);
    }
    .podium-content__podium__content__position__champion.color{
        width: 23rem;
    }
    .podium-content__podium__content__position__champion {
        width: 19rem;
    }
    .podium-content__podium__content__position__image.subcampeon__image img {
        width: 90px;
        height: 90px;
        border-radius: 50%;
    }
    .podium-content__podium__content__position__champion__text__name.baloa-subtitle-2{
        padding: var(--space) 0 var(--space-half) 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-podium-teams/TournamentPodiumTeamsComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qCAAqC;IACrC,+BAA+B;IAC/B,0BAA0B;IAC1B,gBAAgB;IAChB,2CAA2C;AAC/C;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,wBAAwB;IACxB,2BAA2B;IAC3B,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,oCAAoC;IACpC,WAAW;IACX,uCAAuC;IACvC,gCAAgC;GACjC,sFAAsF;IACrF,+CAA+C;AACnD;AACA;IACI,6DAA6D;IAC7D,YAAY;AAChB;AACA;IACI,qCAAqC;IACrC,uCAAuC;IACvC,WAAW;IACX,4BAA4B;IAC5B,kBAAkB;AACtB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;AACzC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,gCAAgC;AACpC;AACA;IACI,gCAAgC;AACpC;AACA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,+EAA+E;IAC/E,kBAAkB;;AAEtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;;IAEI,0BAA0B;IAC1B,gCAAgC;IAChC,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,wBAAwB;IACxB,aAAa;IACb,yBAAyB;IACzB,gCAAgC;IAChC,UAAU;IACV,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;;IAEvB;;IAEA;QACI,QAAQ;QACR,uDAAuD;IAC3D;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,6BAA6B;QAC7B,kBAAkB;QAClB,YAAY;QACZ,yBAAyB;IAC7B;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,2CAA2C;IAC/C;AACJ","sourcesContent":[".podium-content__podium__content {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    grid-gap: var(--space-and-half);\n    gap: var(--space-and-half);\n    align-items: end;\n    /* margin-top: calc(var(--space-x3)*1.6); */\n}\n.podium-content__podium__content__position{\n    display: grid;\n    justify-content: center;\n    align-items: start;\n    margin-top: var(--space);\n    margin-bottom: var(--space);\n    cursor: pointer;\n    justify-items: center;\n}\n.podium-content__podium__content__position__champion{\n    background-color: var(--white-color);\n    width: 100%;\n    /*height: calc(var(--space-x3) * 2.5);*/\n    border-radius: var(--space-half);\n   /* box-shadow: 0px 0px 18px rgb(170 193 182 / 61%), -1px 0px 4px rgb(77 84 81 / 32%);*/\n    box-shadow: -1px 0 4px 0 rgba(77, 84, 81, 0.32);\n}\n.podium-content__podium__content__position__champion.color{\n    background: linear-gradient(180deg, #FFF3BF 0%, #E4D387 100%);\n    width: 20rem;\n}\n.podium-content__podium__content__position__champion__text{\n    margin-top: calc(var(--space-x2) * 2);\n    margin-right: calc(var(--space-x3)*1.6);\n    width: 100%;\n    padding-bottom: var(--space);\n    text-align: center;\n}\n.baloa-subtitle-2.podium-content__podium__content__position__champion__text__title{\n    color: var(--basic-gray-color);\n}\n.podium-content__podium__content__position__champion__text__name.baloa-subtitle-2{\n    color: var(--primary-dark-color);\n}\n\n.podium-content__podium__content__position__champion__text__name_champion.baloa-headline-2 {\n    color: var(--primary-very-dark-color);\n}\n.podium-content__podium__content__position__champion__text__username.baloa-table-column{\n    color: var(--primary-very-dark-color);\n}\n.podium-content__podium__content__position__champion__text__username.baloa-names{\n    color: var(--primary-dark-color);\n}\n.podium-content__podium__content__position__champion__text__username.baloa-username{\n    color: var(--primary-dark-color);\n}\n.podium-content__podium__content__position__image{    \n    border-radius: 50%;\n    background: var(--white-color);\n    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.31) , 0 3px 13px 0 rgba(77, 84, 81, 0.38);\n    position: absolute;\n    \n}\n\n.podium-content__podium__content__position__image.subcampeon__image{\n    width: 112px;\n    height: 112px;\n    margin-top: -60px;\n}\n.podium-content__podium__content__position__image.champion__image{\n    width: 138px;\n    height: 138px;\n    margin-top: -80px;\n}\n.podium-content__podium__content__position__image.third__image{\n    width: 86px;\n    height: 86px;\n    margin-top: -40px;\n}\n\n.podium-content__podium__content__position__image__content {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.podium-content__podium__content__position__image__content .icon-ball.champion  {\n    font-size: 120px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 9px;\n    color: var(--white-color);\n}\n.subcampeon__image .podium-content__podium__content__position__image__content .icon-ball  {\n    font-size: 100px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 6px;\n    color: var(--white-color);\n}\n.third__image .podium-content__podium__content__position__image__content .icon-ball  {\n    font-size: 76px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 5px;\n    color: var(--white-color);\n}\n\n.podium-content__podium__content__position__champion__subtitle{\n    padding: 10px;\n    text-align: center;\n}\n\n.podium-content__podium__content__position__image__content img.no_img{\n\n    padding: var(--space-half);\n    width: calc(var(--space-x3)*1.8);\n    height: calc(var(--space-x3)*1.8);\n    border-radius: 50%;\n}\n\n.podium-content__podium__content__position__image__content img.no_img_champion{\n    width: 100%;\n    border-radius: 50%;\n}\n\n.podium-content__podium__content__position__image__content img.has_img_champion{\n    width: 100%;\n    border-radius: 50%;\n}\n\n.podium-content__podium__content__position__image__content img.has_img{\n\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n}\n\n.podium-content__podium__content__position__coach {\n    border-top: solid 1px #B6B18E;\n    margin-top: var(--space);\n    display: flex;\n    padding-top: var(--space);\n    /* margin-right: var(--space); */\n    width: 80%;\n    margin-left: var(--space-x2);\n    padding-left: 12px;\n}\n\n.podium-content__podium__content__position__coach__image {\n    align-self: center;\n    margin-right: var(--space-half);\n}\n\n.podium-content__podium__content__position__coach__image img.has_img{\n    width: var(--space-x2);\n    height: var(--space-x2);\n    border-radius: 50%;\n}\n\n.podium-content__podium__content__position__coach__image img.no_img{\n    padding: var(--space-quarter);\n    width: var(--space-x2);\n    height: var(--space-x2);\n    border-radius: 50%;\n    background-color: var(--white-color);\n}\n\n.league-tournament-report__podium__container {\n    background-color: var(--white-color);\n    padding-top: 100px;\n    padding-bottom: var(--space-x2);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .podium-content__podium__content {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n\n    }\n\n    .podium-content__podium__content__position:nth-of-type(1) {\n        order: 2;\n        margin-top: calc( var(--space-x3) + var(--space-half) );\n    }\n\n    .podium-content__podium__content__position:nth-of-type(2) {\n        order: 1;\n    }\n    \n    .podium-content__podium__content__position:nth-of-type(3) {\n        order: 3;\n    }\n\n    .podium-content__podium__content__position:nth-of-type(3) .podium-content__podium__content__position__champion__text {\n        margin-top: var(--space-x3);\n    }\n\n    .league-tournament-report__podium__container {        \n        padding-top: 50px;        \n    }    \n\n    .podium-content__podium__content__position__image.champion__image {\n        width: 100px;\n        height: 100px;\n        margin-top: -54px;\n    }\n\n    .podium-content__podium__content__position__image.subcampeon__image {\n        width: 90px;\n        height: 90px;\n        margin-top: -45px;\n    }\n    .third__image .podium-content__podium__content__position__image__content .icon-ball {\n        font-size: 57px;\n    }\n    .podium-content__podium__content__position__image.third__image {\n        width: 66px;\n        height: 66px;\n        margin-top: -32px;\n    }\n    .podium-content__podium__content__position__image.third__image img {\n        width: 100%;\n        height: 100%;\n        border-radius: 50%;\n    }\n\n    .subcampeon__image .podium-content__podium__content__position__image__content .icon-ball {\n        font-size: 78px;\n    }\n\n    .podium-content__podium__content__position__image.champion__image span {\n        font-size: 90px;\n        font-weight: var(--font-bold);\n        border-radius: 50%;\n        padding: 5px;\n        color: var(--white-color);\n    }\n    .podium-content__podium__content__position__champion.color{\n        width: 23rem;\n    }\n    .podium-content__podium__content__position__champion {\n        width: 19rem;\n    }\n    .podium-content__podium__content__position__image.subcampeon__image img {\n        width: 90px;\n        height: 90px;\n        border-radius: 50%;\n    }\n    .podium-content__podium__content__position__champion__text__name.baloa-subtitle-2{\n        padding: var(--space) 0 var(--space-half) 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
